//   document.addEventListener("DOMContentLoaded", function () {
//     document.body.addEventListener("click", function (e) {
//       const btn = e.target.closest(".yotpo-sr-bottom-line-summary");
//       if (btn) {
//         e.preventDefault();
//         const reviewSection = document.querySelector(".yotpo-widget-instance-custom");
//         if (reviewSection) {
//           reviewSection.scrollIntoView({ behavior: "smooth", block: "start" });
//         }
//       }
//     });
//   });

 
// document.addEventListener("DOMContentLoaded", function () {
//     const observer = new MutationObserver(() => {
//       const starsContainer = document.querySelector('.star-container')?.parentElement?.parentElement;
//       if (starsContainer && !starsContainer.querySelector('.custom-rating-text')) {
//         document.querySelectorAll('.star-container').forEach((span, index) => {
//           if(index == 4) {
            
//             span.classList.remove('yotpo-sr-star-empty');
//             span.classList.add('yotpo-sr-star-half');
//             span.innerHTML= `<defs>
// 		    <linearGradient id="yotpo_stars_gradient_0.8563926457371702">
// 		        <stop offset="51%" stop-color="#F0CD66"></stop>
// 		        <stop stop-opacity="1" offset="51%" stop-color="#FFFFFF"></stop>
// 			</linearGradient>
// 		</defs><path style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="#F0CD66" fill="url('#yotpo_stars_gradient_0.8563926457371702')"></path>`;
//           } else {
//             span.classList.remove('yotpo-sr-star-empty');
//             span.classList.add('yotpo-sr-star-full');
//             span.innerHTML= `<defs>
//                 <linearGradient id="yotpo_stars_gradient_0.28508708046692344">
//                     <stop offset="100%" stop-color="#F0CD66"></stop>
//                     <stop stop-opacity="1" offset="100%" stop-color="#FFFFFF"></stop>
//               </linearGradient>
//             </defs><path style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="#F0CD66" fill="url('#yotpo_stars_gradient_0.28508708046692344')"></path>`;
//           }
          
//         });
//         const textEl = document.createElement('span');
//         textEl.className = 'custom-rating-text';
//         textEl.textContent = 'Rated 4.8 out of 5 stars';
//         starsContainer.appendChild(textEl);
//       }
//     });

//     observer.observe(document.body, { childList: true, subtree: true });
// });




// document.addEventListener("DOMContentLoaded", function () {
//   function hideSectionIfNoReviews() {
//     const reviewLabel = document.querySelector('.reviews-qa-label');
//     const reviewAppsection = reviewLabel?.closest('.shopify-section');
//     const yotpoSection = document.querySelector('.yotpo-widget-instance-custom')?.closest('.shopify-section');

//     if (reviewLabel && reviewLabel.textContent.includes("0 Reviews")) {
//       if (yotpoSection) yotpoSection.style.display = "block";
//       if (reviewAppsection) reviewAppsection.style.display = "none";
//       return true; // 0 reviews → RUN syncYotpoReviews
//     } else {
//       if (yotpoSection) yotpoSection.style.display = "none";
//       if (reviewAppsection) reviewAppsection.style.display = "block";
//       return false; // has reviews → DON'T run syncYotpoReviews
//     }
//   }

//   function syncYotpoReviews(root = document) {
//     let changed = 0;
//     const baseText = root.querySelector(".yotpo-bottom-line-basic-text");
//     if (baseText) {
//       const match = baseText.textContent.match(/Based on\s+(\d+)\s+reviews/i);
//       if (match) {
//         const reviewCount = match[1];
//         root.querySelectorAll(".yotpo-sr-bottom-line-text--right-panel").forEach(span => {
//           if (span.dataset.patched === "1") return;
//           span.textContent = `${reviewCount} Reviews`;
//           span.dataset.patched = "1";
//           changed++;
//         });
//       }
//     }
//     return changed;
//   }

//   function runAll() {
//     const isZeroReviews = hideSectionIfNoReviews();
//     if (isZeroReviews) {
//       syncYotpoReviews();
//     }
//   }

//   // Initial run
//   runAll();

//   // On load
//   window.addEventListener("load", runAll);

//   // Observe Yotpo async render
//   const observer = new MutationObserver(() => {
//     clearTimeout(window.__yotpoPatchTimer);
//     window.__yotpoPatchTimer = setTimeout(runAll, 50);
//   });
//   observer.observe(document.body, { childList: true, subtree: true });

//   // Shopify section reload events
//   document.addEventListener("shopify:section:load", runAll);
//   document.addEventListener("shopify:section:unload", runAll);
// });


// document.addEventListener("DOMContentLoaded", function () {
//   function isZeroReviews() {
//     const reviewLabel = document.querySelector('.reviews-qa-label');
//     return reviewLabel && reviewLabel.textContent.includes("0 Reviews");
//   }

//   // ⭐ Force rating to 4.8
//   function patchYotpoRating(root = document) {
//     const ratingEl = root.querySelector(".yotpo-bottom-line-left-panel.yotpo-bottom-line-score");
//     if (ratingEl && ratingEl.dataset.patched !== "1") {
//       ratingEl.childNodes.forEach(node => {
//         if (node.nodeType === 3 && node.textContent.trim().match(/^\d+(\.\d+)?$/)) {
//           node.textContent = "4.8"; // 👈 forced rating
//         }
//       });
//       ratingEl.dataset.patched = "1";
//     }
//   }

//   // 🧹 Remove "Based on"
//   function patchYotpoBasedOn(root = document) {
//     const el = root.querySelector(".yotpo-bottom-line-basic-text");
//     if (el && el.dataset.cleaned !== "1") {
//       el.textContent = el.textContent.replace(/^Based on\s*/i, "");
//       el.dataset.cleaned = "1";
//     }
//   }

//   function runAll(root = document) {
//     if (isZeroReviews()) {
//       patchYotpoRating(root);
//       patchYotpoBasedOn(root);
//     }
//   }

//   // Run once on load
//   runAll();

//   window.addEventListener("load", runAll);

//   // Observe Yotpo async renders
//   const observer = new MutationObserver(() => {
//     clearTimeout(window.__yotpoPatchTimer3);
//     window.__yotpoPatchTimer3 = setTimeout(runAll, 50);
//   });
//   observer.observe(document.body, { childList: true, subtree: true });

//   // Shopify section reload
//   document.addEventListener("shopify:section:load", runAll);
// });
 

// (function () {
//   function patchYotpoRatings(root = document) {
//     const ratingEl = root.querySelector(".avg-score.font-color-gray-darker");
//     if (ratingEl && ratingEl.dataset.patched !== "1") {
//       ratingEl.childNodes.forEach(node => {
//         if (node.nodeType === 3 && node.textContent.trim().match(/^\d+(\.\d+)?$/)) {
//           node.textContent = "4.8"; // 👈 forced rating
//         }
//       });
//       ratingEl.dataset.patched = "1";
//     }
//   }

//   function run() { patchYotpoRatings(); }

//   document.addEventListener("DOMContentLoaded", run);
//   window.addEventListener("load", run);

//   const obs = new MutationObserver(() => {
//     clearTimeout(window.__yotpoPatchTimer);
//     window.__yotpoPatchTimer = setTimeout(run, 50);
//   });
//   obs.observe(document.body, { childList: true, subtree: true });

//   document.addEventListener("shopify:section:load", run);
// })();

document.addEventListener("DOMContentLoaded", function () {
    document.body.addEventListener("click", function (e) {
      const btn = e.target.closest(".yotpo-sr-bottom-line-summary");
      if (btn) {
        e.preventDefault();
        const reviewSection = document.querySelector(".yotpo-widget-instance-custom");
        if (reviewSection) {
          reviewSection.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
    });
  });

 
document.addEventListener("DOMContentLoaded", function () {
    const observer = new MutationObserver(() => {
      const starsContainer = document.querySelector('.star-container')?.parentElement?.parentElement;
      if (starsContainer && !starsContainer.querySelector('.custom-rating-text')) {
        document.querySelectorAll('.star-container').forEach((span, index) => {
          if(index == 4) {
            
            span.classList.remove('yotpo-sr-star-empty');
            span.classList.add('yotpo-sr-star-half');
            span.innerHTML= `<defs>
		    <linearGradient id="yotpo_stars_gradient_0.8563926457371702">
		        <stop offset="51%" stop-color="#F0CD66"></stop>
		        <stop stop-opacity="1" offset="51%" stop-color="#FFFFFF"></stop>
			</linearGradient>
		</defs><path style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="#F0CD66" fill="url('#yotpo_stars_gradient_0.8563926457371702')"></path>`;
          } else {
            span.classList.remove('yotpo-sr-star-empty');
            span.classList.add('yotpo-sr-star-full');
            span.innerHTML= `<defs>
                <linearGradient id="yotpo_stars_gradient_0.28508708046692344">
                    <stop offset="100%" stop-color="#F0CD66"></stop>
                    <stop stop-opacity="1" offset="100%" stop-color="#FFFFFF"></stop>
              </linearGradient>
            </defs><path style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="#F0CD66" fill="url('#yotpo_stars_gradient_0.28508708046692344')"></path>`;
          }
          
        });
        const textEl = document.createElement('span');
        textEl.className = 'custom-rating-text';
        textEl.textContent = ' Rated 4.8/5 Stars';
        starsContainer.appendChild(textEl);
        setTimeout(function() {
          document.querySelectorAll(".yotpo-widget-instance").forEach(el => {
            el.classList.add("yotpo-ready");
          });
        }, 500)
        
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
});




document.addEventListener("DOMContentLoaded", function () {
  function hideSectionIfNoReviews() {
    const reviewLabel = document.querySelector('.reviews-qa-label');
    const reviewAppsection = reviewLabel?.closest('.shopify-section');
    const yotpoSection = document.querySelector('.yotpo-widget-instance-custom')?.closest('.shopify-section');

    if (reviewLabel && reviewLabel.textContent.includes("0 Reviews")) {
      if (yotpoSection) yotpoSection.style.display = "block";
      if (reviewAppsection) reviewAppsection.style.display = "none";
      return true; // 0 reviews → RUN syncYotpoReviews
    } else {
      if (yotpoSection) yotpoSection.style.display = "none";
      if (reviewAppsection) reviewAppsection.style.display = "block";
      return false; // has reviews → DON'T run syncYotpoReviews
    }
  }

  function syncYotpoReviews(root = document) {
    // Check if root is a valid DOM element
    if (!(root instanceof Element) && !(root instanceof Document)) {
      root = document;
    }
    
    let changed = 0;
    const baseText = root.querySelector(".yotpo-bottom-line-basic-text");
    if (baseText) {
      const match = baseText.textContent.match(/Based on\s+(\d+)\s+reviews/i);
      if (match) {
        const reviewCount = match[1];
        root.querySelectorAll(".yotpo-sr-bottom-line-text--right-panel").forEach(span => {
          if (span.dataset.patched === "1") return;
          span.textContent = `${reviewCount} Reviews`;
          span.dataset.patched = "1";
          changed++;
        });
      }
    }
    if (changed > 0) {
      // Reveal widget only after patching
      document.querySelectorAll(".yotpo-widget-instance").forEach(el => {
        el.classList.add("yotpo-ready");
        el.style.opacity = 1;
      });
    }
    return changed;
  }

  function runAll() {
    const isZeroReviews = hideSectionIfNoReviews();
    if (isZeroReviews) {
      syncYotpoReviews();
    }
  }

  // Initial run
  runAll();

  // On load
  window.addEventListener("load", runAll);

  // Observe Yotpo async render
  const observer = new MutationObserver(() => {
    clearTimeout(window.__yotpoPatchTimer);
    window.__yotpoPatchTimer = setTimeout(runAll, 50);
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Shopify section reload events
  document.addEventListener("shopify:section:load", runAll);
  document.addEventListener("shopify:section:unload", runAll);
});


document.addEventListener("DOMContentLoaded", function () {
  function isZeroReviews() {
    const reviewLabel = document.querySelector('.reviews-qa-label');
    return reviewLabel && reviewLabel.textContent.includes("0 Reviews");
  }

  // ⭐ Force rating to 4.8
  function patchYotpoRating(root = document) {
    // Check if root is a valid DOM element
    if (!(root instanceof Element) && !(root instanceof Document)) {
      root = document;
    }
    
    const ratingEl = root.querySelector(".yotpo-bottom-line-left-panel.yotpo-bottom-line-score");
    if (ratingEl && ratingEl.dataset.patched !== "1") {
      ratingEl.childNodes.forEach(node => {
        if (node.nodeType === 3 && node.textContent.trim().match(/^\d+(\.\d+)?$/)) {
          node.textContent = "4.8"; // 👈 forced rating
        }
      });
      ratingEl.dataset.patched = "1";
    }
  }

  // 🧹 Remove "Based on"
  function patchYotpoBasedOn(root = document) {
    // Check if root is a valid DOM element
    if (!(root instanceof Element) && !(root instanceof Document)) {
      root = document;
    }
    
    const el = root.querySelector(".yotpo-bottom-line-basic-text");
    if (el && el.dataset.cleaned !== "1") {
      el.textContent = el.textContent.replace(/^Based on\s*/i, "");
      el.dataset.cleaned = "1";
    }
  }

  function runAll(root = document) {
    // Check if root is a valid DOM element
    if (!(root instanceof Element) && !(root instanceof Document)) {
      root = document;
    }
    
    if (isZeroReviews()) {
      patchYotpoRating(root);
      patchYotpoBasedOn(root);
    }
  }

  // Run once on load
  runAll();

  window.addEventListener("load", runAll);

  // Observe Yotpo async renders
  const observer = new MutationObserver((mutations) => {
    clearTimeout(window.__yotpoPatchTimer3);
    window.__yotpoPatchTimer3 = setTimeout(() => {
      // Check each mutation for added nodes
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) { // Element node
            runAll(node);
          }
        });
      });
      // Also run on the whole document
      runAll();
    }, 50);
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Shopify section reload
  document.addEventListener("shopify:section:load", (e) => {
    if (e.detail && e.detail.container) {
      runAll(e.detail.container);
    } else {
      runAll();
    }
  });
});
 

(function () {
  function patchYotpoRatings(root = document) {
    // Check if root is a valid DOM element
    if (!(root instanceof Element) && !(root instanceof Document)) {
      root = document;
    }
    
    const ratingEl = root.querySelector(".avg-score.font-color-gray-darker");
    if (ratingEl && ratingEl.dataset.patched !== "1") {
      ratingEl.childNodes.forEach(node => {
        if (node.nodeType === 3 && node.textContent.trim().match(/^\d+(\.\d+)?$/)) {
          node.textContent = "4.8"; // 👈 forced rating
        }
      });
      ratingEl.dataset.patched = "1";
    }
  }

  function run(root = document) { 
    // Check if root is a valid DOM element
    if (!(root instanceof Element) && !(root instanceof Document)) {
      root = document;
    }
    patchYotpoRatings(root); 
  }

  document.addEventListener("DOMContentLoaded", run);
  window.addEventListener("load", run);

  const obs = new MutationObserver((mutations) => {
    clearTimeout(window.__yotpoPatchTimer);
    window.__yotpoPatchTimer = setTimeout(() => {
      // Check each mutation for added nodes
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) { // Element node
            run(node);
          }
        });
      });
      // Also run on the whole document
      run();
    }, 50);
  });
  obs.observe(document.body, { childList: true, subtree: true });

  document.addEventListener("shopify:section:load", (e) => {
    if (e.detail && e.detail.container) {
      run(e.detail.container);
    } else {
      run();
    }
  });
})();


// old -review js
//   document.addEventListener("DOMContentLoaded", function () {
//     document.body.addEventListener("click", function (e) {
//       const btn = e.target.closest(".yotpo-sr-bottom-line-summary");
//       if (btn) {
//         e.preventDefault();
//         const reviewSection = document.querySelector(".yotpo-widget-instance-custom");
//         if (reviewSection) {
//           reviewSection.scrollIntoView({ behavior: "smooth", block: "start" });
//         }
//       }
//     });
//   });

 
// document.addEventListener("DOMContentLoaded", function () {
//     const observer = new MutationObserver(() => {
//       const starsContainer = document.querySelector('.star-container')?.parentElement?.parentElement;
//       if (starsContainer && !starsContainer.querySelector('.custom-rating-text')) {
//         document.querySelectorAll('.star-container').forEach((span, index) => {
//           if(index == 4) {
            
//             span.classList.remove('yotpo-sr-star-empty');
//             span.classList.add('yotpo-sr-star-half');
//             span.innerHTML= `<defs>
// 		    <linearGradient id="yotpo_stars_gradient_0.8563926457371702">
// 		        <stop offset="51%" stop-color="#F0CD66"></stop>
// 		        <stop stop-opacity="1" offset="51%" stop-color="#FFFFFF"></stop>
// 			</linearGradient>
// 		</defs><path style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="#F0CD66" fill="url('#yotpo_stars_gradient_0.8563926457371702')"></path>`;
//           } else {
//             span.classList.remove('yotpo-sr-star-empty');
//             span.classList.add('yotpo-sr-star-full');
//             span.innerHTML= `<defs>
//                 <linearGradient id="yotpo_stars_gradient_0.28508708046692344">
//                     <stop offset="100%" stop-color="#F0CD66"></stop>
//                     <stop stop-opacity="1" offset="100%" stop-color="#FFFFFF"></stop>
//               </linearGradient>
//             </defs><path style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="#F0CD66" fill="url('#yotpo_stars_gradient_0.28508708046692344')"></path>`;
//           }
          
//         });
//         const textEl = document.createElement('span');
//         textEl.className = 'custom-rating-text';
//         textEl.textContent = 'Rated 4.8 out of 5 stars';
//         starsContainer.appendChild(textEl);
//       }
//     });

//     observer.observe(document.body, { childList: true, subtree: true });
// });




// document.addEventListener("DOMContentLoaded", function () {
//   function hideSectionIfNoReviews() {
//     const reviewLabel = document.querySelector('.reviews-qa-label');
//     const reviewAppsection = reviewLabel?.closest('.shopify-section');
//     const yotpoSection = document.querySelector('.yotpo-widget-instance-custom')?.closest('.shopify-section');

//     if (reviewLabel && reviewLabel.textContent.includes("0 Reviews")) {
//       if (yotpoSection) yotpoSection.style.display = "block";
//       if (reviewAppsection) reviewAppsection.style.display = "none";
//       return true; // 0 reviews → RUN syncYotpoReviews
//     } else {
//       if (yotpoSection) yotpoSection.style.display = "none";
//       if (reviewAppsection) reviewAppsection.style.display = "block";
//       return false; // has reviews → DON'T run syncYotpoReviews
//     }
//   }

//   function syncYotpoReviews(root = document) {
//     let changed = 0;
//     const baseText = root.querySelector(".yotpo-bottom-line-basic-text");
//     if (baseText) {
//       const match = baseText.textContent.match(/Based on\s+(\d+)\s+reviews/i);
//       if (match) {
//         const reviewCount = match[1];
//         root.querySelectorAll(".yotpo-sr-bottom-line-text--right-panel").forEach(span => {
//           if (span.dataset.patched === "1") return;
//           span.textContent = `${reviewCount} Reviews`;
//           span.dataset.patched = "1";
//           changed++;
//         });
//       }
//     }
//     return changed;
//   }

//   function runAll() {
//     const isZeroReviews = hideSectionIfNoReviews();
//     if (isZeroReviews) {
//       syncYotpoReviews();
//     }
//   }

//   // Initial run
//   runAll();

//   // On load
//   window.addEventListener("load", runAll);

//   // Observe Yotpo async render
//   const observer = new MutationObserver(() => {
//     clearTimeout(window.__yotpoPatchTimer);
//     window.__yotpoPatchTimer = setTimeout(runAll, 50);
//   });
//   observer.observe(document.body, { childList: true, subtree: true });

//   // Shopify section reload events
//   document.addEventListener("shopify:section:load", runAll);
//   document.addEventListener("shopify:section:unload", runAll);
// });


// document.addEventListener("DOMContentLoaded", function () {
//   function isZeroReviews() {
//     const reviewLabel = document.querySelector('.reviews-qa-label');
//     return reviewLabel && reviewLabel.textContent.includes("0 Reviews");
//   }

//   // ⭐ Force rating to 4.8
//   function patchYotpoRating(root = document) {
//     const ratingEl = root.querySelector(".yotpo-bottom-line-left-panel.yotpo-bottom-line-score");
//     if (ratingEl && ratingEl.dataset.patched !== "1") {
//       ratingEl.childNodes.forEach(node => {
//         if (node.nodeType === 3 && node.textContent.trim().match(/^\d+(\.\d+)?$/)) {
//           node.textContent = "4.8"; // 👈 forced rating
//         }
//       });
//       ratingEl.dataset.patched = "1";
//     }
//   }

//   // 🧹 Remove "Based on"
//   function patchYotpoBasedOn(root = document) {
//     const el = root.querySelector(".yotpo-bottom-line-basic-text");
//     if (el && el.dataset.cleaned !== "1") {
//       el.textContent = el.textContent.replace(/^Based on\s*/i, "");
//       el.dataset.cleaned = "1";
//     }
//   }

//   function runAll(root = document) {
//     if (isZeroReviews()) {
//       patchYotpoRating(root);
//       patchYotpoBasedOn(root);
//     }
//   }

//   // Run once on load
//   runAll();

//   window.addEventListener("load", runAll);

//   // Observe Yotpo async renders
//   const observer = new MutationObserver(() => {
//     clearTimeout(window.__yotpoPatchTimer3);
//     window.__yotpoPatchTimer3 = setTimeout(runAll, 50);
//   });
//   observer.observe(document.body, { childList: true, subtree: true });

//   // Shopify section reload
//   document.addEventListener("shopify:section:load", runAll);
// });
 

// (function () {
//   function patchYotpoRatings(root = document) {
//     const ratingEl = root.querySelector(".avg-score.font-color-gray-darker");
//     if (ratingEl && ratingEl.dataset.patched !== "1") {
//       ratingEl.childNodes.forEach(node => {
//         if (node.nodeType === 3 && node.textContent.trim().match(/^\d+(\.\d+)?$/)) {
//           node.textContent = "4.8"; // 👈 forced rating
//         }
//       });
//       ratingEl.dataset.patched = "1";
//     }
//   }

//   function run() { patchYotpoRatings(); }

//   document.addEventListener("DOMContentLoaded", run);
//   window.addEventListener("load", run);

//   const obs = new MutationObserver(() => {
//     clearTimeout(window.__yotpoPatchTimer);
//     window.__yotpoPatchTimer = setTimeout(run, 50);
//   });
//   obs.observe(document.body, { childList: true, subtree: true });

//   document.addEventListener("shopify:section:load", run);
// })();